export const ACTIVE_SERVICE_PROVIDER = {
  id: 1,
  name: 'Active'
}

export const PROSPECT_SERVICE_PROVIDER = {
  id: 2,
  name: 'Prospect'
}

export const NOT_ACTIVE_SERVICE_PROVIDER = {
  id: 3,
  name: 'Not-Active'
}



// WEBPACK FOOTER //
// ./src/constants/serviseProvider.js